import overflowBlocker from '@/utils/overflowBlocker';

export default {
    /**
     * Created hook
     *
     */
    created() {
        overflowBlocker(true);
    },

    /**
     * Destroyed hook
     *
     */
    destroyed() {
        overflowBlocker(false);
    },
};
